{
  "16d2a82fd6e5b96f": "Información del turno",
  "175a2747a35d5e64": "Inicio del turno: {{shiftStartTime}}",
  "19c73a5cdf346d96": "Profesional",
  "247a45c3415e9336": "Sin información",
  "2d8cbda0cc14afb6": "ETA: {{etaTime}}",
  "383b084da568040f": "Nuestra estimación: {{etaTime}} de llegada",
  "3fba2c78314f1915": "Tipo: {{shiftQualification}}",
  "42b42fa1ddc8ef9a": "Hora Estimada de Llegada",
  "460b3a7da007b7af": "Chat",
  "4e952b41752d7990": "ETA del trabajador en vivo",
  "63eb561dbf27be58": "Ocultar en el mapa",
  "6e032f5357f0e998": "{{etaTime}} de llegada",
  "6fc3b01a3743e0bb": "Sin turnos próximos",
  "7371031c223e1545": "Mostrar en el mapa",
  "82eab215405dc397": "Actualizado {{updatedAt}}",
  "9b64e6f7d70b02b0": "{{workerName}} aún no ha salido para su turno",
  "9e86fb3406204da6": "Mostrar todo en el mapa",
  "c71c7bd6882ad7c9": "Llegó a {{arrivedTime}}",
  "e97aa9177af0106d": "Trabajador reportó: {{workerDeclaredEta}} de llegada",
  "ff8059dc6752afdd": "Acciones"
}
